var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-12" },
    [
      _c("v-card-title", [_vm._v(" Edit Tech Area " + _vm._s(_vm.name) + " ")]),
      _c("v-divider"),
      _c(
        "v-form",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2" } },
                    [
                      _c("pga-text-field", {
                        attrs: {
                          label: "Code",
                          "key-error": "Code",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.code,
                          callback: function ($$v) {
                            _vm.code = $$v
                          },
                          expression: "code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("pga-text-field", {
                        attrs: {
                          label: "Name",
                          "key-error": "Name",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-select", {
                        attrs: {
                          "item-value": "Id",
                          "item-text": "Title",
                          items: _vm.ListBusinessLines,
                          label: "Business Line",
                          "key-error": "BusinessLineId",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.businessLineId,
                          callback: function ($$v) {
                            _vm.businessLineId = $$v
                          },
                          expression: "businessLineId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-select", {
                        attrs: {
                          "item-value": "Id",
                          "item-text": "CostCenter",
                          items: _vm.ListAreaManagers,
                          label: "Cost Center",
                          "key-error": "AreaManagerId",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.areaManagerId,
                          callback: function ($$v) {
                            _vm.areaManagerId = $$v
                          },
                          expression: "areaManagerId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }